export const CUSTOMER_DEFAULT_LIST_SORT = 'name';
export const CUSTOMER_DEFAULT_LIST_ORDER = 'asc';
export const CUSTOMER_CONNECTION_TIME = 10;
